<fieldset class="display-mode">
    <legend class="sr-only">
        <ng-container i18n="@@hermes.accessibility.display-mode">Display mode</ng-container>
        <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
        <ng-container i18n="@@hermes.accessibility.refresh_grid"
            >Select item will refresh the gallery below
        </ng-container>
        <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
    </legend>

    <div class="display-mode-button grid-button">
        <input
            type="radio"
            name="display-mode"
            id="display-mode-grid"
            value="grid"
            (change)="handleChange('grid')"
            [checked]="displayMode === 'grid'" />
        <label [attr.for]="'display-mode-grid'">
            <h-svg-icon [name]="'grid-square'" [class.checked]="displayMode === 'grid'"></h-svg-icon>
            <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.grid">grid</span>
        </label>
    </div>

    <div class="display-mode-button">
        <input
            type="radio"
            name="display-mode"
            id="display-mode-list"
            value="list"
            (change)="handleChange('list')"
            [checked]="displayMode === 'list'" />
        <label [attr.for]="'display-mode-list'">
            <h-svg-icon [name]="'square'" [class.checked]="displayMode === 'list'"></h-svg-icon>
            <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.list">list</span>
        </label>
    </div>
</fieldset>
